document.addEventListener('DOMContentLoaded', function () {
  function initCatPreview() {
    var triggers = document.querySelectorAll('[data-cat-preview-trigger]');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('mouseenter', function () {
        var targetKey = trigger.getAttribute('data-cat-preview-trigger');
        var wrapper = trigger.closest('.sub-menu-wrapper');
        if (!wrapper) return;

        var panels = wrapper.querySelectorAll('[data-cat-preview-panel]');
        panels.forEach(function (panel) {
          panel.classList.remove('is-active');
        });

        var activePanel = wrapper.querySelector('[data-cat-preview-panel="' + targetKey + '"]');
        if (activePanel) {
          activePanel.classList.add('is-active');
        }
      });
    });
  }

  initCatPreview();
});